/**
 * Selects between the two authenticateUser shapes.
 *
 * v1 is this app's original request: PWA-identifying headers (`isPwa`,
 * `appname`, `Package-Name`, …) plus `pwaAuthData` and `isNewSignupFlowEnabled`
 * in the payload.
 *
 * v2 mirrors verticaltv-pwa, which omits all of those. The backend rejects a
 * signup from an existing full-app user with errorCode 1013 when it can see the
 * request came from the PWA, so v2 is what lets such a user sign in here.
 *
 * Off by default: an unset variable leaves every auth request exactly as it was.
 */
export const isAuthV2Enabled = (): boolean =>
  (process.env.REACT_APP_AUTH_V2 || '').trim() === 'true';
